import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useMediaQuery } from '@mantine/hooks'
import { useCallback, useState } from 'react'
import React from 'react'

import styles from './kdt-ugm-5th.module.scss'

interface IUgmBenefitProps {
  benefitDetailList: {
    id: number
    point: string
    title: string
    contents: string[]
  }[]
}

export const UgmAccordion = ({ benefitDetailList }: IUgmBenefitProps) => {
  const [openItems, setOpenItems] = useState<{ [key: number]: boolean }>({
    0: true,
  })

  const isMobile = useMediaQuery('(max-width: 1023px)')

  const onOpenHandler = useCallback((id: number) => {
    setOpenItems(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }))
  }, [])

  return (
    <ul className="flex flex-col gap-3 px-4 lg:px-0">
      {benefitDetailList.map(detail => {
        const isOpen = isMobile ? !!openItems[detail.id] : true
        return (
          <li
            key={detail.id}
            className="group list-none overflow-hidden"
            onClick={() => {
              if (isMobile) {
                onOpenHandler(detail.id)
              }
            }}
          >
            <div className="cursor-pointer list-none group-open:pb-1">
              <div className="flex flex-row items-center gap-5">
                <div
                  className={`${
                    isOpen ? 'rounded-t-lg' : 'rounded-lg'
                  } flex w-full items-center justify-between gap-x-2 bg-[#383838] px-4 py-3 lg:bg-gray-900 lg:px-6 lg:pb-5 lg:pt-6`}
                >
                  <div className="flex flex-1 flex-col items-start justify-center gap-2 lg:flex-row lg:items-center lg:justify-start lg:gap-4">
                    <p className="text-xs font-bold text-yellow-450 lg:max-w-fit lg:rounded lg:bg-[rgba(255,119,16,0.2)] lg:px-1.5 lg:py-[2.5px] lg:text-sm">
                      {detail.point}
                    </p>
                    <p className="text-base font-semibold text-white lg:text-lg lg:font-bold">
                      {detail.title}
                    </p>
                  </div>
                  {isMobile && (
                    <ChevronDownIcon
                      className={`${
                        isOpen ? 'rotate-180 transform text-white' : 'text-label-alternative'
                      } ml-auto h-auto w-4 shrink-0 grow-0`}
                    />
                  )}
                </div>
              </div>
            </div>

            {isOpen && (
              <div className="flex w-full">
                <div className="flex-1 rounded-b-lg bg-[#383838] px-4 pb-3 lg:bg-gray-900 lg:px-6 lg:pb-6">
                  <div className="flex flex-col rounded bg-[#2F2F2F] px-4 py-3 lg:bg-inherit lg:p-0">
                    {detail.contents.map(content => (
                      <div
                        key={content}
                        className="flex flex-col border-t-[0.5px] border-[#444] py-2 first:pt-0 last:pb-0 first-of-type:border-t-0 lg:py-5"
                      >
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section11} text-sm leading-normal text-label-assistive lg:text-base`}
                        >
                          {content}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </li>
        )
      })}
    </ul>
  )
}
